
import React, { Component}  from 'react';

import { FormProvider, FormContext } from 'core/FormProvider';
import Layout from 'components/Dashboard/Layout';
import { YellowButton } from 'ui/Button';
import { UserContext } from 'components/User';
import { ServiceForm } from './Form';


export default class ServiceAdd extends Component {

  static contextType = UserContext;

  componentDidMount() {
    document.title = 'Новая услуга';
  }

  onDetail = (item) => {
    this.props.history.push(`/service`);
  };

  render() {
    return (
      <FormProvider
        url={'catalog/service'}
        postSave={(item) => this.onDetail(item)}
        postSaveMessage={'Услуга добавлена'}
        item={{
          department: this.context.data.department_active,
          financial_schema: 'RE_EXPOSED',
          tariffication: 'FIXED',
          type: 'TARIFF',
          is_active: true
        }}
      >
        <FormContext.Consumer>
        {context => {
          const { loading } = context;
          return (
            <Layout>
              <Layout.Header
                title={'Создание услуги'}
                backUrl={'/service'}
              />

              <Layout.ContentSimple>
                <ServiceForm />

                <div className={'mt-30'}>
                  <YellowButton
                    onClick={(e) => context.handleSubmit(e)}
                    size={'large'}
                    disabled={loading}
                  >
                    Создать услугу
                  </YellowButton>

                </div>
              </Layout.ContentSimple>
            </Layout>
          )
        }}
        </FormContext.Consumer>
      </FormProvider>
    )
  }
}
